import {Tour} from "@app/common/interfaces/tour";

const mapUrl = 'https://www.google.com/maps/embed/v1/directions?key=AIzaSyA2cScXrqnzvtrhX9Qnh7MO6m-HOF5oGJQ&';

export const TOURS: Tour[] = [
  {
    urlKey: 'khor-virap',
    id: '1',
    disabled: false,
    url: '../../../../assets/img/tours/khor-virap.jpg',
    price: '25000',
    groupPrice: '45000',
    title: 'tours.khor_virap.title',
    description: 'tours.khor_virap.desc',
    map: mapUrl + 'origin=Yerevan&destination=Khor+Virap+monastery',
    slider: [
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_2.jpg'},
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_3.jpg'},
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_4.jpg'},
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_6.jpg'}
    ],
    content: {
      title: 'khor_virap.title',
      description: [
        {
          strong: '',
          text: 'khor_virap.mainBlog',
        }
      ]
    },
    video: {
      url: 'https://www.youtube.com/embed/5xDanbMwKsg?autoplay=1',
      bgImage: '../../../../assets/img/video-background/khor-virab.jpg'
    }
  },
  {
    urlKey: 'lake-sevan',
    id: '2',
    disabled: false,
    url: '../../../../assets/img/tours/sevan.jpg',
    price: '35000',
    groupPrice: '55000',
    title: 'tours.lake_sevan.title',
    description: 'tours.lake_sevan.desc',
    map: mapUrl + 'origin=Yerevan&destination=Sevanavanq+monastery',
    slider: [
      {url: '../../../assets/img/places/SEVAN/Sevan_2.jpg'},
      {url: '../../../assets/img/places/SEVAN/Sevan_3.jpg'},
      {url: '../../../assets/img/places/SEVAN/Sevan_4.jpg'},
      {url: '../../../assets/img/places/SEVAN/Sevan_5.jpg'}
    ],
    content: {
      title: 'lake_sevan.title',
      description: [
        {
          strong: '',
          text: 'lake_sevan.mainBlog',
        }
      ]
    },
  },
  {
    urlKey: 'etchmiadzin-zvartnots',
    id: '3',
    disabled: false,
    url: '../../../../assets/img/tours/zvartnoc.jpg',
    price: '30000',
    groupPrice: '50000',
    title: 'tours.etchmiadzin_zvartnots.title',
    description: 'tours.etchmiadzin_zvartnots.desc',
    map: mapUrl + 'origin=Yerevan&destination=Etchmiadzin+catedral&waypoints=Zvartnoc+Catedral',
    slider: [
      {url: '../../../assets/img/places/EJMIADZIN/Etchmiadzin_2.jpg'},
      {url: '../../../assets/img/places/EJMIADZIN/Etchmiadzin_3.jpg'},
      {url: '../../../assets/img/places/EJMIADZIN/Etchmiadzin_4.jpg'},
      {url: '../../../assets/img/places/EJMIADZIN/Etchmiadzin_5.jpg'},

      {url: '../../../assets/img/places/ZVARTNOC/Zvartnoc_2.jpg'},
      {url: '../../../assets/img/places/ZVARTNOC/Zvartnoc_3.jpg'},
      {url: '../../../assets/img/places/ZVARTNOC/Zvartnoc_4.jpg'},
      {url: '../../../assets/img/places/ZVARTNOC/Zvartnoc_5.jpg'}
    ],
    content: {
      title: 'Etchmiadzin Cathedral / Zvartnots Cathedral',
      description: [
        {
          strong: '',
          text: 'vagharshapat.mainBlog'
        },
        {
          strong: '',
          text: 'etchmiadzin.mainBlog'
        },
        {
          strong: '',
          text: 'zvartnots.mainBlog'
        }
      ]
    },
    video: {
      url: 'https://www.youtube.com/embed/t3zA7Ti3OkE?autoplay=1',
      bgImage: 'assets/img/video-background/garni-geghard.jpg'
    }
  },
  {
    urlKey: 'geghard-garni',
    id: '4',
    disabled: false,
    url: '../../../../assets/img/tours/geghard.jpg',
    price: '30000',
    groupPrice: '50000',
    title: 'tours.geghard_garni.title',
    description: 'tours.geghard_garni.desc', // TODO Armen check with Harut // and "Hin Areni" wine factory (tour and tasting)
    map: mapUrl + 'origin=Yerevan&destination=Geghard+Monastery&waypoints=Garni+Temple',
    slider: [
      {url: '../../../assets/img/places/GEGHARD/Geghard_2.jpg'},
      {url: '../../../assets/img/places/GEGHARD/Geghard_3.jpg'},
      {url: '../../../assets/img/places/GEGHARD/Geghard_4.jpg'},
      {url: '../../../assets/img/places/GEGHARD/Geghard_5.jpg'},

      {url: '../../../assets/img/places/GARNI/Garni_1.jpg'},
      {url: '../../../assets/img/places/GARNI/Garni_2.jpg'},
      {url: '../../../assets/img/places/GARNI/Garni_3.jpg'},
      {url: '../../../assets/img/places/GARNI/Garni_4.jpg'}
    ],
    content: {
      title: 'Medieval Monastery Geghard / Temple of Garni',
      description: [
        {
          strong: '',
          text: 'geghard.mainBlog'
        },
        {
          strong: '',
          text: 'garni.mainBlog'
        }
      ]
    }
  },
  {
    urlKey: 'khor-virap-noravank',
    id: '5',
    disabled: false,
    url: '../../../../assets/img/tours/khor_virap-noravanq.jpg',
    price: '20000',
    groupPrice: '30000',
    title: 'tours.khor_virap_noravank.title',
    description: 'tours.khor_virap_noravank.desc',
    map: mapUrl + 'origin=Yerevan&destination=Noravanq+monastery&waypoints=Khor+Virap',
    slider: [
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_2.jpg'},
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_3.jpg'},
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_4.jpg'},
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_6.jpg'},

      {url: '../../../assets/img/places/NORAVANQ/Noravanq-1.jpg'},
      {url: '../../../assets/img/places/NORAVANQ/Noravanq-2.jpg'},
      {url: '../../../assets/img/places/NORAVANQ/Noravanq-3.jpg'},
      {url: '../../../assets/img/places/NORAVANQ/Noravanq-4.jpg'}
    ],
    content: {
      title: 'Khor Virap Monastery / Noravank Monastery',
      description: [
        {
          strong: '',
          text: 'khor_virap.mainBlog',
        },
        {
          strong: '',
          text: 'noravank.mainBlog',
        },
      ]
    }
  },
  {
    urlKey: 'sevan-dilijan',
    id: '6',
    disabled: false,
    url: '../../../../assets/img/tours/sevan-dilijan.jpg',
    price: '45000',
    groupPrice: '60000',
    title: 'tours.sevan_dilijan.title',
    description: 'tours.sevan_dilijan.desc',
    map: mapUrl + 'origin=Yerevan&destination=Dilijan+town&waypoints=Sevanavanq|Parz+lake|Haghardzin+monastery|Goshavanq+Monastery',
    slider: [
      {url: '../../../assets/img/places/SEVAN/Sevan_2.jpg'},
      {url: '../../../assets/img/places/SEVAN/Sevan_3.jpg'},
      {url: '../../../assets/img/places/SEVAN/Sevan_4.jpg'},
      {url: '../../../assets/img/places/SEVAN/Sevan_5.jpg'},

      {url: '../../../assets/img/places/DILIJAN/Dilijan_3.jpg'},
      {url: '../../../assets/img/places/DILIJAN/Dilijan_2.jpg'},
      {url: '../../../assets/img/places/DILIJAN/Dilijan_1.jpg'},
      {url: '../../../assets/img/places/DILIJAN/Dilijan_4.jpg'},
      {url: '../../../assets/img/places/DILIJAN/Dilijan_5.jpg'}
    ],
    content: {
      title: 'Lake Sevan / Spa Town Dilijan',
      description: [
        {
          strong: '',
          text: 'lake_sevan.mainBlog',
        },
        {
          strong: '',
          text: 'sevanavank.mainBlog',
        },
        {
          strong: '',
          text: 'dilijan.mainBlog',
        },
        {
          strong: '',
          text: 'goshavank.mainBlog',
        },
        {
          strong: '',
          text: 'haghartsin.mainBlog',
        },
        {
          strong: '',
          text: 'lake_parz.mainBlog',
        },
      ]
    }
  },
  {
    urlKey: 'tsaghkadzor-hankavan',
    id: '7',
    disabled: false,
    url: '../../../../assets/img/tours/caxkadzor-hanqavan.jpg',
    price: '40000',
    groupPrice: '55000',
    title: 'tours.tsaghkadzor_hankavan.title',
    description: 'tours.tsaghkadzor_hankavan.desc',
    map: mapUrl + 'origin=Yerevan&destination=Hanqavan&waypoints=Tsakhadzor&zoom=10',
    slider: [
      {url: '../../../assets/img/places/TSAGHADZOR/Tsakhadzor_2.jpg'},
      {url: '../../../assets/img/places/TSAGHADZOR/Tsakhadzor_3.jpg'},
      {url: '../../../assets/img/places/TSAGHADZOR/Tsakhadzor_4.jpg'},
      {url: '../../../assets/img/places/TSAGHADZOR/Tsakhadzor_5.jpg'},

      {url: '../../../assets/img/places/HANQAVAN/Hanqavan_1.jpg'},
      {url: '../../../assets/img/places/HANQAVAN/Hanqavan_2.jpg'},
      {url: '../../../assets/img/places/HANQAVAN/Hanqavan_3.jpg'},
      {url: '../../../assets/img/places/HANQAVAN/Hanqavan_4.jpg'}
    ],
    content: {
      title: 'Tsaghkadzor spa town / Hankavan',
      description: [
        {
          strong: '',
          text: 'tsaghkadzor.mainBlog',
        },
        {
          strong: '',
          text: 'hanqavan.mainBlog',
        },
      ]
    }
  },
  {
    urlKey: 'dilijan-haghartsin-goshavank',
    id: '8',
    disabled: false,
    url: '../../../../assets/img/tours/haghardzin.jpg',
    price: '50000',
    groupPrice: '65000',
    title: 'tours.dilijan_haghartsin_goshavank.title',
    description: 'tours.dilijan_haghartsin_goshavank.desc',
    map: mapUrl + 'origin=Yerevan&destination=Parz+Lake&waypoints=Goshavanq+Monastery|Haghardzin+monastery',
    slider: [
      {url: '../../../assets/img/places/HAGHARDZIN/Haghardzin_2.jpg'},
      {url: '../../../assets/img/places/HAGHARDZIN/Haghardzin_3.jpg'},
      {url: '../../../assets/img/places/HAGHARDZIN/Haghardzin_4.jpg'},

      {url: '../../../assets/img/places/GOSHAVANQ/GOSHAVANQ_1.jpg'},
      {url: '../../../assets/img/places/GOSHAVANQ/GOSHAVANQ_2.jpg'},
      {url: '../../../assets/img/places/GOSHAVANQ/GOSHAVANQ_3.jpg'},

      {url: '../../../assets/img/places/PARZ_LAKE/PARZ_1.jpg'},
      {url: '../../../assets/img/places/PARZ_LAKE/PARZ_2.jpg'},
      {url: '../../../assets/img/places/PARZ_LAKE/PARZ_3.jpg'}
    ],
    content: {
      title: 'Dilijan Spa Town / Haghartsin Monastery / Goshavank Monastery / Parz Lake',
      description: [
        {
          strong: '',
          text: 'dilijan.mainBlog',
        },
        {
          strong: '',
          text: 'goshavank.mainBlog',
        },
        {
          strong: '',
          text: 'haghartsin.mainBlog',
        },
        {
          strong: '',
          text: 'lake_parz.mainBlog',
        },
      ]
    }
  },
  {
    urlKey: 'tatev-noravank',
    id: '9',
    disabled: false,
    url: '../../../../assets/img/tours/tatev.jpg',
    price: '70000',
    groupPrice: '85000',
    title: 'tours.tatev_noravank.title',
    description: 'tours.tatev_noravank.desc',
    map: mapUrl + 'origin=Yerevan&destination=Tatev+monastery&waypoints=Khor+Virap+Monastery|Noravanq+monastery',
    slider: [
      {url: '../../../assets/img/places/TATEV/TATEV_1.jpg'},
      {url: '../../../assets/img/places/TATEV/TATEV_2.jpg'},
      {url: '../../../assets/img/places/TATEV/TATEV_3.jpg'},
      {url: '../../../assets/img/places/TATEV/TATEV_4.jpg'},
      {url: '../../../assets/img/places/TATEV/TATEV_5.jpg'},

      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_2.jpg'},
      {url: '../../../assets/img/places/NORAVANQ/Noravanq-1.jpg'}
    ],
    content: {
      title: 'Tatev Monastery / Khor Virap or Noravanq Monastery',
      description: [
        {
          strong: '',
          text: 'tatev.mainBlog',
        },
        {
          strong: '',
          text: 'khor_virap.mainBlog',
        },
        {
          strong: '',
          text: 'noravank.mainBlog',
        },
      ]
    }
  },
  {
    urlKey: 'jermuk-noravank',
    id: '10',
    disabled: false,
    url: '../../../../assets/img/tours/jermuk.jpg',
    price: '60000',
    groupPrice: '75000',
    title: 'tours.jermuk_noravank.title',
    description: 'tours.jermuk_noravank.desc',
    map: mapUrl + 'origin=Yerevan&destination=Jermuk&waypoints=Khor+Virap+Monastery|Noravanq+monastery',
    slider: [
      {url: '../../../assets/img/places/JERMUK/JERMUK_1.jpg'},
      {url: '../../../assets/img/places/JERMUK/JERMUK_2.jpg'},
      {url: '../../../assets/img/places/JERMUK/JERMUK_3.jpg'},
      {url: '../../../assets/img/places/JERMUK/JERMUK_4.jpg'},

      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_2.jpg'},
      {url: '../../../assets/img/places/KHOR_VIRAP/Khor_Virap_6.jpg'},

      {url: '../../../assets/img/places/NORAVANQ/Noravanq-1.jpg'},
      {url: '../../../assets/img/places/NORAVANQ/Noravanq-3.jpg'}
    ],
    content: {
      title: 'Mountain Spa Town Jermuk / Khor Virap Monastery / Noravank Monastery',
      description: [
        {
          strong: '',
          text: 'jermuk.mainBlog',
        },
        {
          strong: '',
          text: 'khor_virap.mainBlog',
        },
        {
          strong: '',
          text: 'noravank.mainBlog',
        },
      ]
    }
  },
  {
    urlKey: 'haghartsin-goshavank',
    id: '11',
    disabled: false,
    url: '../../../../assets/img/tours/tbilisi.jpg',
    price: '65000',
    groupPrice: '76000',
    title: 'tours.haghartsin_goshavank.title',
    description: 'tours.haghartsin_goshavank.desc',
    map: mapUrl + 'origin=Yerevan&destination=Tblilisi&waypoints=Goshavanq+Monastery|Hagharcin+monastery|Parz+lake',
    slider: [
      {url: '../../../assets/img/places/TBILISI/TBILISI_2.jpg'},
      {url: '../../../assets/img/places/GOSHAVANQ/GOSHAVANQ_1.jpg'},
      {url: '../../../assets/img/places/HAGHARDZIN/Haghardzin_4.jpg'},
      {url: '../../../assets/img/places/PARZ_LAKE/PARZ_1.jpg'}
    ],
    content: {
      title: 'Transfer To Tbilisi / Haghartsin Monastery or Goshavank Monastery or Parz Lake',
      description: [
        {
          strong: 'Transfer To Tbilisi',
          text: ''
        },
        {
          strong: '',
          text: 'goshavank.mainBlog',
        },
        {
          strong: '',
          text: 'haghartsin.mainBlog',
        },
        {
          strong: '',
          text: 'lake_parz.mainBlog',
        },
      ]
    }
  },
  {
    urlKey: 'etchmiadzin',
    id: '12',
    disabled: false,
    url: '../../../../assets/img/tours/etchmiadzin.jpg',
    price: '30000',
    groupPrice: '40000',
    title: 'tours.etchmiadzin.title',
    description: 'tours.etchmiadzin.desc',
    map: mapUrl + 'origin=Yerevan&destination=Etchmiadzin+catedral&waypoints=Zvartnoc+Catedral|Gayane+church|Hripsime+church&zoom=13',
    slider: [
      {url: '../../../assets/img/places/EJMIADZIN/Etchmiadzin_2.jpg'},
      {url: '../../../assets/img/places/EJMIADZIN/Etchmiadzin_3.jpg'},
      {url: '../../../assets/img/places/EJMIADZIN/Etchmiadzin_4.jpg'},
      {url: '../../../assets/img/places/EJMIADZIN/Etchmiadzin_5.jpg'},

      {url: '../../../assets/img/places/ZVARTNOC/Zvartnoc_2.jpg'},
      {url: '../../../assets/img/places/ZVARTNOC/Zvartnoc_3.jpg'},
      {url: '../../../assets/img/places/ZVARTNOC/Zvartnoc_4.jpg'},
      {url: '../../../assets/img/places/ZVARTNOC/Zvartnoc_5.jpg'}
    ],
    content: {
      title: 'Etchmiadzin Cathedral / Saint Hripsime Church / Saint Gayane Church / Zvartnots Cathedral',
      description: [
        {
          strong: '',
          text: 'vagharshapat.mainBlog'
        },
        {
          strong: '',
          text: 'hripsime_church.mainBlog'
        },
        {
          strong: '',
          text: 'gayane_church.mainBlog'
        },
        {
          strong: '',
          text: 'etchmiadzin.mainBlog'
        },
        {
          strong: '',
          text: 'zvartnots.mainBlog'
        }
      ]
    }
  },
  {
    urlKey: 'sanahin-haghpat',
    id: '13',
    disabled: false,
    url: '../../../../assets/img/tours/sanahin-hagphat.jpg',
    price: '70000',
    groupPrice: '85000',
    title: 'tours.sanahin_haghpat.title',
    description: 'tours.sanahin_haghpat.desc',
    map: mapUrl + 'origin=Yerevan&destination=Haghpat+Monastery&waypoints=Sanahin+Monastery',
    slider: [
      {url: '../../../assets/img/places/SANAHIN/SANAHIN_1.jpg'},
      {url: '../../../assets/img/places/SANAHIN/SANAHIN_2.jpg'},
      {url: '../../../assets/img/places/SANAHIN/SANAHIN_3.jpg'},
      {url: '../../../assets/img/places/SANAHIN/SANAHIN_4.jpg'},
      {url: '../../../assets/img/places/SANAHIN/SANAHIN_5.jpg'},
      {url: '../../../assets/img/places/SANAHIN/SANAHIN_6.jpg'},

      {url: '../../../assets/img/places/HAGHPAT/HAGHPAT_1.jpg'},
      {url: '../../../assets/img/places/HAGHPAT/HAGHPAT_2.jpg'},
      {url: '../../../assets/img/places/HAGHPAT/HAGHPAT_3.jpg'},
      {url: '../../../assets/img/places/HAGHPAT/HAGHPAT_4.jpg'},
      {url: '../../../assets/img/places/HAGHPAT/HAGHPAT_5.jpg'},
      {url: '../../../assets/img/places/HAGHPAT/HAGHPAT_6.jpg'},
      {url: '../../../assets/img/places/HAGHPAT/HAGHPAT_7.jpg'},
      {url: '../../../assets/img/places/HAGHPAT/HAGHPAT_8.jpg'},
      {url: '../../../assets/img/places/HAGHPAT/HAGHPAT_9.jpg'}
    ],
    content: {
      title: 'Sanahin Monastery / Haghpat Monastery',
      description: [
        {
          strong: '',
          text: 'zvartnots.mainBlog'
        },
        {
          strong: '',
          text: 'haghpat.mainBlog'
        },
      ]
    }
  },
  {
    urlKey: 'saghmosavank-hovhannavank',
    id: '14',
    disabled: false,
    url: '../../../../assets/img/tours/saghmosavanq.jpg',
    price: '30000',
    groupPrice: '40000',
    title: 'tours.saghmosavank_hovhannavank.title',
    description: 'tours.saghmosavank_hovhannavank.desc',
    map: mapUrl + 'origin=Yerevan&destination=Saghmosavank+monastery&waypoints=Hovhannavank+monastery',
    slider: [
      {url: '../../../assets/img/places/SAGHMOSAVANQ/SAGHMOSAVANQ_2.jpg'},
      {url: '../../../assets/img/places/SAGHMOSAVANQ/SAGHMOSAVANQ_3.jpg'},
      {url: '../../../assets/img/places/SAGHMOSAVANQ/SAGHMOSAVANQ_4.jpg'},
      {url: '../../../assets/img/places/SAGHMOSAVANQ/SAGHMOSAVANQ_5.jpg'},
      {url: '../../../assets/img/places/SAGHMOSAVANQ/SAGHMOSAVANQ_6.jpg'},

      {url: '../../../assets/img/places/HOVHANNAVANQ/HOVHANNAVANQ_1.jpg'},
      {url: '../../../assets/img/places/HOVHANNAVANQ/HOVHANNAVANQ_2.jpg'},
      {url: '../../../assets/img/places/HOVHANNAVANQ/HOVHANNAVANQ_3.jpg'},
      {url: '../../../assets/img/places/HOVHANNAVANQ/HOVHANNAVANQ_4.jpg'},
      {url: '../../../assets/img/places/HOVHANNAVANQ/HOVHANNAVANQ_5.jpg'}


    ],
    content: {
      title: 'Saghmosavank Monastery / Hovhannavank Monastery',
      description: [
        {
          strong: '',
          text: 'saghmosavank.mainBlog'
        },
        {
          strong: '',
          text: 'hovhannavank.mainBlog'
        },
      ]
    }
  },
  {
    urlKey: 'tour-in-yerevan',
    id: '15',
    disabled: false,
    url: '../../../../assets/img/tours/yerevan.jpg',
    price: '15',
    groupPrice: '20',
    title: 'tours.tour_in_yerevan.title',
    description: 'tours.tour_in_yerevan.desc',
    map: mapUrl + 'origin=Yerevan+Republic+Square&destination=Matenadaran&waypoints=Erebuni+Fortress|Cicernakaberd',
    slider: [
      {url: '../../../assets/img/places/YEREVAN/YEREVAN_1.jpg'},
      {url: '../../../assets/img/places/YEREVAN/YEREVAN_2.jpg'},
      {url: '../../../assets/img/places/YEREVAN/YEREVAN_3.jpg'},
      {url: '../../../assets/img/places/YEREVAN/YEREVAN_4.jpg'},
      {url: '../../../assets/img/places/YEREVAN/YEREVAN_5.jpg'},
      {url: '../../../assets/img/places/YEREVAN/YEREVAN_6.jpg'},
      {url: '../../../assets/img/places/YEREVAN/YEREVAN_7.jpg'}
    ],
    content: {
      title: 'Tour in Yerevan',
      description: [
        {
          strong: '',
          text: 'yerevan.mainBlog'
        },
        {
          strong: '',
          text: 'tsitsernakaberd.mainBlog'
        },
        {
          strong: '',
          text: 'erebuni.mainBlog'
        },
        {
          strong: '',
          text: 'matenadaran.mainBlog'
        },
      ]
    }
  },
];
